import { RefObject, useEffect } from 'react'

export const useDropdownClose = (
  wrapperRef: RefObject<HTMLElement | null>,
  isOpen: boolean,
  close: () => void,
) => {
  useEffect(() => {
    if (!isOpen) return

    const handleEscape = (event: KeyboardEvent) => {
      if (event.key !== 'Escape') return
      event.preventDefault()
      event.stopPropagation()
      close()
    }

    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement
      if (target.closest('.basic-select__menu')) return
      if (wrapperRef.current && !wrapperRef.current.contains(target)) close()
    }

    document.addEventListener('keydown', handleEscape)
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('keydown', handleEscape)
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [close, isOpen, wrapperRef])
}
